import React from "react";
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";
import Header from '../header';
import Footer from '../footer';
import './projects.css';
import Carousel from '../carousel';
import Rashid1 from '../../images/rashid-library.webp';
import Rashid2 from '../../images/rashid-library1.webp';
import Rashid3 from '../../images/rashid-library2.webp';
import Rashid4 from '../../images/rashid-library.webp';
import Rashid5 from '../../images/rashid-library1.webp';
function rashid() {
  return (
    
    <>
    <div className="boxed_wrapper" id="project">
    <Helmet>
        <title>Mohammed Bin Rashid Library Acoustical Plaster Ceiling in Auditorium - Moov Group</title>
        <meta name="description" content=""/>
        <meta property="og:title" content="Mohammed Bin Rashid Library Auditorium" />
        <meta property="og:description" content=""/>
        <meta property="og:image" content="../../images/moovgroup-office.webp" />
        <link rel="canonical" href="https://www.moovgroup.com/rashid-library-acoustics" />
        <link rel="alternate" href="https://www.moovgroup.com/rashid-library-acoustics" hreflang="en-GB" />
    </Helmet>
    <Header />
    <div id="moov">
    <section className="breadcrumb-section projects-bg">
        <div className="container">
            <h1 className="page-title">Mohammed Bin Rashid Library</h1>
            <span className="page-tag">Acoustical Plaster Ceiling in Auditorium</span>
        </div>
    </section>
    
    <section className="portfolio-section section-gap-top" id="portfolio">
        <div className="container">
            
            <div className="portfolio-items">
		        <div className="portfolio-item portfolio-style-four">
		            <div className="row align-items-center">
				        <div className="col-lg-6 col-md-6">
				            <div className="portfolio-container1">
				               <h1 className="portfolio-previous">BEE'AH Head Quarters</h1>
				            </div>
				        </div>
				        <div className="col-lg-6 col-md-6">
				            <div className="portfolio-container2">
				                <Link to="/beeah-acoustics" className="portfolio-next">Next &raquo;</Link>
				            </div>
                        </div>
                    </div>
                    <span className="line-footer"></span>
                </div>
            </div>
           
            
            <div className="row portfolio-items portfolio-filter" id="portsub"  style={{position: "relative", height: "580px"}}>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item design web" style={{position: "absolute", right: "0px", bottom: "0px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Rashid1} alt="Rashid Library Acoustics - 1" />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Sharjah</span>
                            <h5 className="title"><Link to="/rashid-library-acoustics">Mohammed Bin Rashid Library</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 filter-item game" style={{position: "absolute", right: "295px", bottom: "0px"}}>
                    <div className="portfolio-item big-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Rashid2} alt="Rashid Library Acoustics - 2"  />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Sharjah</span>
                            <h5 className="title"><Link to="/rashid-library-acoustics">Mohammed Bin Rashid Library</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item web" style={{position: "absolute", right: "885px", bottom: "0px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Rashid3} alt="Rashid Library Acoustics - 3" />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Sharjah</span>
                            <h5 className="title"><Link to="/rashid-library-acoustics">Mohammed Bin Rashid Library</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item design" style={{position: "absolute", right: "0px", bottom: "290px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Rashid4} alt="Rashid Library Acoustics - 4" />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Sharjah</span>
                            <h5 className="title"><Link to="/rashid-library-acoustics">Mohammed Bin Rashid Library</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item game web" style={{position: "absolute", right: "885px", bottom: "290px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Rashid5} alt="Rashid Library Acoustics - 5" />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Sharjah</span>
                            <h5 className="title"><Link to="/rashid-library-acoustics">Mohammed Bin Rashid Library</Link></h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className="recently-project-style2-area">
            <div className="container">
                <div className="sec-title text-center">
                    <div className="pro-title">Our Projects</div>
                    <p className="bottom-text">we have successfully completed more than 900 acoustic projects<br /> over the last 17 years across the Middle East.<br /> Have a glance at our recently compeleted projects</p>
                </div>
                <Carousel />
            </div>
        </section>
        </div>
    </div>
<Footer />
</>
  );
}

export default rashid;